import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  AWARD_EVENT_DETAILS_ACTION_TYPE,
  award_event_id,
  AWARD_LIST_ACTION_TYPE,
  AWARD_PROFILE_CHANGE_SEQ_ACTION_TYPE,
  AWARD_PROFILE_DETAILS_ACTION_TYPE,
  AWARD_PROFILE_FORM_PUBLISH_ACTION_TYPE,
  AwardEventDetailUrl,
  AwardProfileChangeSeqUrl,
  AwardProfileDetailUrl,
  awardProfileFormPublishUrl,
  DELETE_AWARD_EVENT_ACTION_TYPE,
  DELETE_AWARD_PROFILE_ACTION_TYPE,
  deleteAwardEventUrl,
  deleteAwardProfileUrl,
  getAwardEventListUrl,
  headers,
  INSERT_MILESTONE_MASTER_ACTION_TYPE,
  insertMilestoneMasterUrl,
  insertUpdateAwardProfileApplicationFeeUrl,
  insertUpdateAwardProfileApplicationSectionUrl,
  insertUpdateAwardProfileMilestoneUrl,
  insertUpdateAwardProfileScoringPatternUrl,
  insertUpdateAwardProfileUrl,
  IU_AWARD_EVENT_JURY_ACTION_TYPE,
  IU_AWARD_EVENT_MILESTONE_ACTION_TYPE,
  IU_AWARD_PROFILE_ACTION_TYPE,
  IU_AWARD_PROFILE_APPLICATION_FEE_ACTION_TYPE,
  IU_AWARD_PROFILE_APPLICATION_SECTION_ACTION_TYPE,
  IU_AWARD_PROFILE_MILESTONE_ACTION_TYPE,
  IU_AWARD_PROFILE_SCORING_PATTERN_ACTION_TYPE,
  IUAwardEventJuryUrl,
  IUAwardEventMilestoneUrl,
  user_id,
} from "../../utils/constants";

export const insert_milestoneMaster_action =
  (milestone_name, mode) => async (dispatch) => {
    try {
      const mapdata = {
        user_id:
          sessionStorage.getItem("user_id") != ""
            ? sessionStorage.getItem("user_id")
            : null,
        milestone_name: milestone_name != "" ? milestone_name : "",
        mode: mode != "" ? mode : "",
      };

      const res = await axiosPost(insertMilestoneMasterUrl, mapdata, headers);
      dispatch({
        type: INSERT_MILESTONE_MASTER_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const get_award_event_list_action = (Event_Name, is_active) => async (dispatch) => {
  try {
    const mapdata = {
      Event_Name: Event_Name,
      is_active: is_active
    };
    const params = {
      Event_Name: mapdata.Event_Name === "" ? null : mapdata.Event_Name,
      is_active: is_active === 0 ? 0 : 1
    };
    const res = await axiosGet(getAwardEventListUrl, params, headers);
    dispatch({
      type: AWARD_LIST_ACTION_TYPE,
      payload: res,
    });
    return res; // No need to wrap in Promise.resolve()
  } catch (err) {
    return Promise.reject(err);
  }
};
export const award_event_detail_action =
  (award_event_id) => async (dispatch) => {
    try {
      const params = {
        user_id:
          sessionStorage.getItem("award event_id") == 2
            ? sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null
            : null,
        award_event_id: award_event_id,
      };
      const res = await axiosGet(AwardEventDetailUrl, params, headers);

      dispatch({
        type: AWARD_EVENT_DETAILS_ACTION_TYPE,
        payload: res,
      });

      return res;
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const awardEventMilestone_insertUpdate_action =
  (
    award_event_id, Event_Name, From_date, To_date, launch_date, award_address, award_state, award_country,
    Event_Description, milestoneList, weightage_round1, weightage_round2
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          award_event_id: award_event_id != null ? award_event_id : null,
          Event_Name: Event_Name != null ? Event_Name : null,
          Event_Description: Event_Description != null ? Event_Description : null,
          From_date: From_date != null ? From_date : null,
          To_date: To_date != null ? To_date : null,
          launch_date: launch_date != null ? launch_date : null,
          award_address: award_address, award_state: award_state, award_country: award_country,
          milestoneList: milestoneList,
          weightage_round1: weightage_round1, weightage_round2: weightage_round2
        };

        const res = await axiosPost(IUAwardEventMilestoneUrl, mapdata, headers);
        dispatch({
          type: IU_AWARD_EVENT_MILESTONE_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const awardEventJury_insertUpdate_action =
  (
    award_event_id, awardEventJuryList
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          award_event_id: award_event_id != null ? award_event_id : null,
          awardEventJuryList: awardEventJuryList
        };

        const res = await axiosPost(IUAwardEventJuryUrl, mapdata, headers);
        dispatch({
          type: IU_AWARD_EVENT_JURY_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const awardEvent_delete_action = (award_event_id) => async (dispatch) => {
  try {
    const mapdata = {
      user_id: sessionStorage.getItem('user_id'),
      award_event_id: award_event_id,
    };

    const res = await axiosGet(deleteAwardEventUrl, mapdata, headers);
    dispatch({
      type: DELETE_AWARD_EVENT_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const award_profile_detail_action =
  (award_event_id, award_event_profile_id) => async (dispatch) => {
    try {
      const params = {
        user_id: sessionStorage.getItem("user_id") != ""
          ? sessionStorage.getItem("user_id") : null,
        award_event_id: award_event_id,
        award_event_profile_id: award_event_profile_id
      };
      const res = await axiosGet(AwardProfileDetailUrl, params, headers);

      dispatch({
        type: AWARD_PROFILE_DETAILS_ACTION_TYPE,
        payload: res,
      });

      return res;
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const insertUpdate_awardProfile_action =
  (
    award_event_profile_id, award_event_id, award_name,
    category_id, applicantTypeList, target_applicant_id, award_type,
    nomination_process_id, is_gst_applicable, description, eligibility_criteria,
    screening_process, jury_selection_criteria, list_of_supporting_elements,
    theme, important_instructions, is_active, seq_no, section_label
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          award_event_profile_id: award_event_profile_id != null ? award_event_profile_id : null,
          award_event_id: award_event_id != null ? award_event_id : null,
          award_name: award_name != "" ? award_name : "",
          category_id: category_id != null ? category_id : null,
          description: description != "" ? description : "",
          applicantTypeList: applicantTypeList != [] ? applicantTypeList : [],
          target_applicant_id:
            target_applicant_id != null ? target_applicant_id : null,
          award_type: award_type != "" ? award_type : "",
          is_gst_applicable: is_gst_applicable != null ? is_gst_applicable : null,
          eligibility_criteria:
            eligibility_criteria != "" ? eligibility_criteria : "",
          screening_process: screening_process != "" ? screening_process : "",
          jury_selection_criteria:
            jury_selection_criteria != "" ? jury_selection_criteria : "",
          nomination_process_id:
            nomination_process_id != null ? nomination_process_id : null,
          list_of_supporting_elements:
            list_of_supporting_elements != "" ? list_of_supporting_elements : "",
          theme: theme != "" ? theme : "", important_instructions: important_instructions != "" ? important_instructions : "",
          is_active: is_active != 0 ? 1 : 0,
          seq_no: seq_no,
          section_label: section_label
        };

        const res = await axiosPost(
          insertUpdateAwardProfileUrl,
          mapdata,
          headers
        );
        dispatch({
          type: IU_AWARD_PROFILE_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const insertUpdate_awardProfile_applicationSection_action = (data) => async (dispatch) => {
  try {
    const mapdata = {
      user_id: sessionStorage.getItem('user_id'),
      award_event_profile_id: data.award_event_profile_id || '',
      award_event_profile_declaration: data.award_event_profile_declaration || '',
      award_event_profile_declaration_message: data.award_event_profile_declaration_message || '',
      applicationSectionNameList: data.applicationSectionNameList || [],
      applicationSectionFieldList: data.applicationSectionFieldList || [],
      applicationSectionOptionsList: data.applicationSectionOptionsList || []
    };

    const res = await axiosPost(
      insertUpdateAwardProfileApplicationSectionUrl,
      mapdata,
      headers
    );
    dispatch({
      type: IU_AWARD_PROFILE_APPLICATION_SECTION_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const insertUpdate_awardProfile_scoringPattern_action =
  (
    scoringPatternList, scoringPatternOptionsList, scoringOptionTicksList, scoringOptionUploadList
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          scoringPatternList: scoringPatternList != [] ? scoringPatternList : [],
          scoringPatternOptionsList: scoringPatternOptionsList != [] ? scoringPatternOptionsList : [],
          scoringOptionTicksList: scoringOptionTicksList != [] ? scoringOptionTicksList : [],
          scoringOptionUploadList: scoringOptionUploadList != [] ? scoringOptionUploadList : []
        };

        const res = await axiosPost(
          insertUpdateAwardProfileScoringPatternUrl,
          mapdata,
          headers
        );
        dispatch({
          type: IU_AWARD_PROFILE_SCORING_PATTERN_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const awardProfileMilestone_insertUpdate_action =
  (
    award_event_profile_id,
    milestoneList
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          award_event_profile_id: award_event_profile_id != null ? award_event_profile_id : null,
          milestoneList: milestoneList,
        };

        const res = await axiosPost(insertUpdateAwardProfileMilestoneUrl, mapdata, headers);
        dispatch({
          type: IU_AWARD_PROFILE_MILESTONE_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const awardProfileApplicationFee_insertUpdate_action =
  (award_event_id,
    award_event_profile_id,
    applicationFeeList
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          award_event_id: award_event_id != null ? award_event_id : null,
          award_event_profile_id: award_event_profile_id != null ? award_event_profile_id : null,
          applicationFeeList: applicationFeeList,
        };

        const res = await axiosPost(insertUpdateAwardProfileApplicationFeeUrl, mapdata, headers);
        dispatch({
          type: IU_AWARD_PROFILE_APPLICATION_FEE_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const awardProfile_delete_action = (award_event_id, award_event_profile_id) => async (dispatch) => {
  try {
    const mapdata = {
      user_id: user_id,
      award_event_id: award_event_id,
      award_event_profile_id: award_event_profile_id
    };

    const res = await axiosGet(deleteAwardProfileUrl, mapdata, headers);
    dispatch({
      type: DELETE_AWARD_PROFILE_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
export const awardProfile_formPublish_action = (award_event_id, award_event_profile_id, publish_status) =>
  async (dispatch) => {
    try {
      const mapdata = {
        user_id:
          sessionStorage.getItem("user_id") != ""
            ? sessionStorage.getItem("user_id")
            : null,
        award_event_id: award_event_id,
        award_event_profile_id: award_event_profile_id != null ? award_event_profile_id : null,
        publish_status: publish_status,
      };

      const res = await axiosPost(awardProfileFormPublishUrl, mapdata, headers);
      dispatch({
        type: AWARD_PROFILE_FORM_PUBLISH_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const awardProfile_changeSeq_action = (award_event_id, category_sequence_list) =>
  async (dispatch) => {
    try {
      const mapdata = {
        user_id:
          sessionStorage.getItem("user_id") != ""
            ? sessionStorage.getItem("user_id")
            : null,
        award_event_id: award_event_id,
        category_sequence_list
      };

      const res = await axiosPost(AwardProfileChangeSeqUrl, mapdata, headers);
      dispatch({
        type: AWARD_PROFILE_CHANGE_SEQ_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };